<template>
    <div class="NavIndicators">
        <div
            class="NavIndicators-item"
            v-for="index in total"
            :key="index"
            :class="itemModifiers(index)"
        ></div>
    </div>
</template>

<script>
export default {
    name: 'NavIndicators',
    props: {
        total: {
            type: Number,
            required: true,
        },
        activeItem: {
            type: Number,
            required: true,
        },
    },
    methods: {
        itemModifiers(index) {
            const { activeItem } = this
            return {
                'NavIndicators-item--active': activeItem === index - 1,
            }
        },
    },
}
</script>

<style src="styles/components/NavIndicators.styl" lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/components/NavIndicators.vue